import type { components } from '@/api/typeApi'

import type { SubnetStatus } from '../domain/subnetStatus'

import { deleteSubnet, fetchSubnets, patchSubnet, postSubnet } from './api'

export const subnetRepository = {
  async list() {
    const { data } = await fetchSubnets()
    return (data?.items || []) as unknown as {
      cidr: string
      clusterId?: string | null
      clusterName?: string
      excludedRanges: string[]
      gateway: string
      totalAvailableIps: number
      id: string
      name: string
      vlan?: number | null
      status: SubnetStatus
    }[]
  },
  async create(data: {
    name: string
    cidr: string
    ipType: string
    excludedRanges: string[]
    vlan: number | null
    gateway: string
  }) {
    return postSubnet(data)
  },
  async update(
    subnetId: string,
    body: components['schemas']['UpdateSubnetRequest'],
  ) {
    return patchSubnet(subnetId, body)
  },
  async remove(subnetId: string) {
    return deleteSubnet(subnetId)
  },
}
